import type { SystemStyleObject } from "@chakra-ui/react";

export const selectStylings: SystemStyleObject = {
  "& select.lrn-cloze-select": {
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "lines",
    borderRadius: "md",
    bg: "input",
    color: "base.700",
    height: "auto",
    p: 3,
    marginBottom: 2,

    _focus: {
      outline: "none",
      borderColor: "input.focus",
    },

    _focusVisible: {
      outline: "none",
      borderColor: "input.focus",
    },

    _hover: {
      outline: "none",
      borderColor: "input.focus",
    },
  },
};